import { render, staticRenderFns } from "./shipinDialog.vue?vue&type=template&id=6a153e20&scoped=true&"
import script from "./shipinDialog.vue?vue&type=script&lang=js&"
export * from "./shipinDialog.vue?vue&type=script&lang=js&"
import style0 from "./shipinDialog.vue?vue&type=style&index=0&id=6a153e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a153e20",
  null
  
)

export default component.exports